import api from './HttpService';
import { SETTING } from '../configs/ApiActionUrl';

async function getMailVariable() {
  const res = await api.get(`${SETTING.GET_MAIL_VARIABLE}`);
  return res;
}
async function getPaypal() {
  const res = await api.get(`${SETTING.GET_PAYPAL}`);
  return res;
}

async function updatePaypal(postData) {
  const res = await api.patch(`${SETTING.UPDATE_PAYPAL}`, postData);
  return res;
}

async function getStripe() {
  const res = await api.get(`${SETTING.GET_STRIPE}`);
  return res;
}

async function updateStripe(postData) {
  const res = await api.patch(`${SETTING.UPDATE_STRIPE}`, postData);
  return res;
}

async function getAuthorizeNet() {
  const res = await api.get(`${SETTING.GET_AUTHORIZENET}`);
  return res;
}

async function updateAuthorizeNet(postData) {
  const res = await api.patch(`${SETTING.UPDATE_AUTHORIZENET}`, postData);
  return res;
}

async function getVeem() {
  const res = await api.get(`${SETTING.GET_VEEM}`);
  return res;
}

async function updateVeem(postData) {
  const res = await api.patch(`${SETTING.UPDATE_VEEM}`, postData);
  return res;
}

async function getBankOfAmerica() {
  const res = await api.get(`${SETTING.GET_BANKOFAMERICA}`);
  return res;
}

async function updateBankOfAmerica(postData) {
  const res = await api.patch(`${SETTING.UPDATE_BANKOFAMERICA}`, postData);
  return res;
}

async function getClover() {
  const res = await api.get(`${SETTING.GET_CLOVER}`);
  return res;
}

async function updateClover(postData) {
  const res = await api.patch(`${SETTING.UPDATE_CLOVER}`, postData);
  return res;
}

async function getGeneralSettings() {
  const res = await api.get(`${SETTING.GENERAL_ITEM}`);
  return res;
}

async function updateGeneralSettings(postData) {
  const res = await api.patch(`${SETTING.UPDATE_GENERAL_ITEM}`, postData);
  return res;
}

async function getUserProfile() {
  const res = await api.get(`${SETTING.GET_PROFILE}`);
  return res;
}

async function updateUserProfile(postData) {
  const res = await api.post(`${SETTING.UPDATE_PROFILE}`, postData);
  return res;
}

async function getVerifyMail(code) {
  const res = await api.get(`${SETTING.VERIFY_MAIL}/${code}`);
  return res;
}

async function updateChangePassword(postData) {
  const res = await api.post(`${SETTING.UPDATE_PASSWORD}`, postData);
  return res;
}

async function getAllBank(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  try {
    const res = await api.get(SETTING.BANK_LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function addBank(postData) {
  const res = await api.post(SETTING.ADD_BANK, postData);
  return res;
}

async function getBankItem(code) {
  const res = await api.get(`${SETTING.GET_BANK_ITEM}/${code}`);
  return res;
}

async function updateBank(code, postData) {
  const res = await api.patch(`${SETTING.UPDATE_BANK}/${code}`, postData);
  return res;
}

async function deleteBankItem(code) {
  const res = await api.delete(`${SETTING.DELETE_BANK}/${code}`);
  return res;
}

async function getAllOffice(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  try {
    const res = await api.get(SETTING.OFFICE_LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function addOffice(postData) {
  const res = await api.post(SETTING.ADD_OFFICE, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function getOfficeItem(code) {
  const res = await api.get(`${SETTING.GET_OFFICE_ITEM}/${code}`);
  return res;
}

async function updateOffice(code, postData) {
  const res = await api.post(`${SETTING.UPDATE_OFFICE}/${code}`, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function deleteOfficeItem(code) {
  const res = await api.delete(`${SETTING.DELETE_OFFICE}/${code}`);
  return res;
}

async function getAllSignature(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  try {
    const res = await api.get(SETTING.SIGNATURE_LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function addSignature(postData) {
  const res = await api.post(SETTING.ADD_SIGNATURE, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function getSignatureItem(code) {
  const res = await api.get(`${SETTING.GET_SIGNATURE_ITEM}/${code}`);
  return res;
}

async function updateSignature(code, postData) {
  const res = await api.post(`${SETTING.UPDATE_SIGNATURE}/${code}`, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function deleteSignatureItem(code) {
  const res = await api.delete(`${SETTING.DELETE_SIGNATURE}/${code}`);
  return res;
}

const SettingService = {
  getMailVariable,
  getPaypal,
  updatePaypal,
  getStripe,
  updateStripe,
  getAuthorizeNet,
  updateAuthorizeNet,
  getGeneralSettings,
  updateGeneralSettings,
  getUserProfile,
  updateUserProfile,
  getVerifyMail,
  updateChangePassword,
  getAllBank,
  addBank,
  updateBank,
  getBankItem,
  deleteBankItem,
  getAllOffice,
  addOffice,
  getOfficeItem,
  updateOffice,
  deleteOfficeItem,
  getAllSignature,
  addSignature,
  getSignatureItem,
  updateSignature,
  deleteSignatureItem,
  updateVeem,
  getVeem,
  getBankOfAmerica,
  updateBankOfAmerica,
  updateClover,
  getClover
};

export default SettingService;
